export default __webpack_public_path__ + "static/media/gal-3.0b0fca5f.jpg";